import { Inject, Injectable, Injector, DOCUMENT } from '@angular/core';

import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';

import { filter, take } from 'rxjs/operators';
import { AuthService, CheckUserStatues } from 'app/services/auth.service';
import { Subscription } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FuseSplashScreenService
{
	splashScreenEl: any;
	player: AnimationPlayer;

	checkUserStatusSubscription: Subscription;

	/**
	 * Constructor
	 *
	 * @param {AnimationBuilder} _animationBuilder
	 * @param _document
	 * @param {Router} _router
	 */
	constructor(
		private _animationBuilder: AnimationBuilder,
		@Inject(DOCUMENT) private _document: any,
		private _injector: Injector,
		private _authService: AuthService
	){
		// Initialize
		this._init();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Initialize
	 *
	 * @private
	 */
	private _init(): void
	{
		// Get the splash screen element
		this.splashScreenEl = this._document.body.querySelector('#fuse-splash-screen');

		// If the splash screen element exists...
		if ( this.splashScreenEl ){

			this.checkUserStatusSubscription = this._authService.chekcUserStatus.subscribe(status => {
				if(status !== CheckUserStatues.CHECKED) return;
				this.checkUserStatusSubscription.unsubscribe();

				const router = this._injector.get(Router);
				// In Angular 16 (initialNavigation 'enabledNonBlocking') la navigazione iniziale
				// può concludersi PRIMA del check auth: in quel caso NavigationEnd è già passato
				// e take(1) non scatterebbe mai (splash bloccato). Se già navigato, nascondi subito.
				if(router.navigated){
					setTimeout(() => this.hide());
				}else{
					router.events
					.pipe(
						filter((event => event instanceof NavigationEnd)),
						take(1)
					)
					.subscribe(() => {
						setTimeout(() => {
							this.hide();
						});
					});
				}
			});
			
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	/**
	 * Show the splash screen
	 */
	show(): void
	{
		this.player =
			this._animationBuilder
				.build([
					style({
						opacity: '0',
						zIndex : '99999'
					}),
					animate('400ms ease', style({opacity: '1'}))
				]).create(this.splashScreenEl);

		setTimeout(() => {
			this.player.play();
		}, 0);
	}

	/**
	 * Hide the splash screen
	 */
	hide(): void
	{
		this.player =
			this._animationBuilder
				.build([
					style({opacity: '1'}),
					animate('400ms ease', style({
						opacity: '0',
						zIndex : '-10'
					}))
				]).create(this.splashScreenEl);

		setTimeout(() => {
			this.player.play();
		}, 0);
	}
}
